export default "/_next/static/images/b048cd3c65c6a8d1ea8a6a8e683d26a2.png";